import { SelectInputV2, SelectInputV2Props, SelectOption } from '@frontend/components/basic-forms';
import { ScreenEnumClient } from '@frontend/wizard/api';
import { ScreenType } from '@frontend/wizard/types';
import React, { useEffect, useState } from 'react';

const ID = 'screen-type-select';

const toScreenTypeLabel = (type: string) => type.replace(/_/g, ' ').replace(/\bpin code\b/g, 'PIN-code');

export const ScreenTypeSelect = (props: Omit<SelectInputV2Props<ScreenType>, 'options'>) => {
    const [options, setOptions] = useState<SelectOption<ScreenType>[]>([]);

    useEffect(() => {
        ScreenEnumClient.fetchScreenTypes().then((types) => setOptions(types.map((type) => ({ value: type as ScreenType, label: toScreenTypeLabel(type) }))));
    }, []);

    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            label={props.label || 'Type'}
            options={options}
            value={props.value}
            onSelect={props.onSelect}
        />
    );
};
